import React from "react";

function ErrorModal({message, onClose}) {

    return (
        <div className="voip-modal-overlay">
            <div className="voip-modal-content error-modal">
                <button className="close-btn" onClick={onClose}>✕</button>
                <div className="error-text">
                    <span>{message}</span>
                </div>
            </div>
        </div>
    );
}

export default ErrorModal;

